var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 7V3.50065C14 2.66891 14 2.25304 13.8248 1.99747C13.6717 1.77418 13.4346 1.62249 13.1678 1.57708C12.8623 1.52509 12.4847 1.69937 11.7295 2.04792L2.85901 6.14199C2.18551 6.45284 1.84875 6.60826 1.60211 6.84931C1.38406 7.06241 1.21762 7.32255 1.1155 7.60983C1 7.93478 1 8.30568 1 9.04746V14M14.5 13.5H14.51M1 10.2L1 16.8C1 17.9201 1 18.4802 1.21799 18.908C1.40973 19.2843 1.71569 19.5903 2.09202 19.782C2.51984 20 3.07989 20 4.2 20H15.8C16.9201 20 17.4802 20 17.908 19.782C18.2843 19.5903 18.5903 19.2843 18.782 18.908C19 18.4802 19 17.9201 19 16.8V10.2C19 9.07989 19 8.51984 18.782 8.09202C18.5903 7.71569 18.2843 7.40973 17.908 7.21798C17.4802 7 16.9201 7 15.8 7L4.2 7C3.0799 7 2.51984 7 2.09202 7.21798C1.7157 7.40973 1.40973 7.71569 1.21799 8.09201C1 8.51984 1 9.07989 1 10.2ZM15 13.5C15 13.7761 14.7761 14 14.5 14C14.2239 14 14 13.7761 14 13.5C14 13.2239 14.2239 13 14.5 13C14.7761 13 15 13.2239 15 13.5Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.087417e20e9f07bd649cd5c378fda023.svg";
export { ForwardRef as ReactComponent };